import { Component, Input } from '@angular/core';
import { LabelFieldOptionLinks } from '@lsq-frontend/remote-services/ar-app';
import { DrApplicationService } from '../../../service/dr-application-service';

@Component({
    selector: 'linked-label',
    styleUrls: ['./linked-label.component.scss'],
    templateUrl: './linked-label.component.html'
})
export class LinkedLabel {
    @Input() links: ILinkLabel[];

    constructor(private _arService: DrApplicationService) {}

    public actions(link: ILinkLabel) {
        switch (link.action) {
            case LabelFieldOptionLinks.ActionEnum.Redirect: {
                window.open(link.option, '_blank');
                break;
            }
            case LabelFieldOptionLinks.ActionEnum.Api: {
                this.callApi(link.option);
                break;
            }
            default: {
                break;
            }
        }
    }

    public async callApi(option: string): Promise<void> {
        switch (option) {
            case 'resendEmail':
                await this._arService.sendEmailAddressVerification();
                break;
            case 'resendMFA':
                await this._arService.sendMFACode();
                break;
            default:
                throw new Error('Method not implemented.');
        }
    }
}
export interface ILinkLabel {
    text: string;
    action: string;
    option: string;
}
